/*
 * BlendIn PDP brewing block.
 * Progressive enhancement: server renders the recipes open and visible.
 * This script collapses the block into a click-to-reveal disclosure, and
 * when a product has more than one brew method, upgrades the cards into an
 * ARIA tab interface. If the script never runs, every recipe stays visible.
 */
(function () {
  var roots = document.querySelectorAll('[data-bic-brewing]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var toggle = root.querySelector('[data-bic-brew-toggle]');
    var reveal = root.querySelector('[data-bic-brew-reveal]');
    if (!toggle || !reveal) return;

    // --- Disclosure: collapse by default, toggle on click ---
    function setExpanded(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      reveal.classList.toggle('is-collapsed', !open);
    }
    setExpanded(false);
    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    // --- Tabs: only when there are 2+ methods ---
    var tabsWrap = root.querySelector('[data-bic-brew-tabs]');
    var grid = root.querySelector('[data-bic-brew-grid]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bic-brew-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bic-brew-panel]'));
    if (!tabsWrap || tabs.length < 2) return;

    var bodyEl = root.querySelector('[data-bic-brew-body]');
    var baseId = (bodyEl && bodyEl.id) || 'bic-brew';

    tabsWrap.hidden = false;
    tabsWrap.setAttribute('role', 'tablist');
    tabsWrap.setAttribute('aria-label', 'Brew methods');
    if (grid) grid.classList.add('is-tabbed');

    function panelByIndex(i) {
      for (var n = 0; n < panels.length; n++) {
        if (panels[n].getAttribute('data-index') === String(i)) return panels[n];
      }
      return null;
    }

    tabs.forEach(function (tab) {
      var idx = tab.getAttribute('data-index');
      var panel = panelByIndex(idx);
      var tabId = baseId + '-tab-' + idx;
      var panelId = baseId + '-panel-' + idx;
      tab.setAttribute('role', 'tab');
      tab.id = tabId;
      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('aria-selected', 'false');
      if (panel) {
        tab.setAttribute('aria-controls', panelId);
        panel.setAttribute('role', 'tabpanel');
        panel.id = panelId;
        panel.setAttribute('aria-labelledby', tabId);
        panel.setAttribute('tabindex', '0');
      }
    });

    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
        t.classList.toggle('is-active', selected);
        var panel = panelByIndex(t.getAttribute('data-index'));
        if (panel) panel.classList.toggle('is-active', selected);
      });
      if (focus && tab.focus) tab.focus();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        var next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(next, true); }
      });
    });

    activate(tabs[0]);
  });
})();
